<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Register Parent
    </button>

    <a-modal v-model="visible" title="Register parent">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="savedata">Submit</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Parent's/Guardian's Name">
          <a-input
            placeholder="Name"
            v-decorator="['name', {rules: [{ required: true, message: 'Please input category name!' }, {max: 30, message: 'Must not exceed 30 characters!'}]}]"
          />
        </a-form-item>
        <a-form-item label="Phone" class="mb-">
          <a-input-number
            placeholder="Phone of parent/guardian"
            style="width:50%;"
            v-decorator="['phone', {rules: [{ required: true, message: 'Please input phone!' },]}]"
          />
        </a-form-item>
        <a-form-item label="Email">
          <a-input
            placeholder="Email of parent/guardian"
            v-decorator="['email', { rules: [{ required: true, message: 'Please input email!' },{type: 'email', message: 'The input is not valid email!',}]}]"
          />
        </a-form-item>
        <a-form-item label="Password">
          <a-input-password
            type="password"
            placeholder="Password"
            v-decorator="['password', { rules: [{required: true, message: 'Please input a password!',},{
                            validator: validateToNextPassword,
                          }]}]"
          />
        </a-form-item>
        <a-form-item label="Confirm password">
          <a-input-password
            type="password"
            placeholder="Confirm password"
            v-decorator="['confirm_password', { rules: [{required: true, message: 'Please input a password!'},{
                            validator: compareToFirstPassword,
                          }]}]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'AddParent',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      categories: [],
    }
  },
  watch: {
    formVisible: function(n, o) {
      // console.log('formvisible changed??', n)
      this.visible = n
    },
  },
  methods: {
    showModal() {
      this.visible = true
    },
    validateToNextPassword (rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm_password'], { force: true })
      }
      callback()
    },
    compareToFirstPassword (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('Not same with the password!')
      } else {
        callback()
      }
    },
    savedata: function() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          // clearform(this.form)
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the new product!`,
            onOk: () => {
              this.$http.post('/api/parent/single/registration', {
                name: values.name,
                email: values.email,
                country_code: '91',
                phone: values.phone,
                password: values.password,
                logged_in_platform: 1,
                relation_with_student: 1,
                status: 1,
                code: values.code,
              })
                .then((resp) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  if (resp.status === 200) {
                    this.$notification['success']({
                      message: 'Parent registered successfully',
                      description: `${values.name} registered successfully!`,
                    })
                  } else {
                    this.$notification['warning']({
                      message: 'Unknown Error',
                      description: `There appears to be an error while submitting data. Response from server: ${resp.status} ${resp.message}`,
                    })
                  }
                  this.form.resetFields()
                })
                .catch((err) => {
                  this.loading = false
                  this.$neoNotify.error(err)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>

<style>

</style>
